const NUM_STEPS = 32;

export {NUM_STEPS};